import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SimpleGrid } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import ProgressLoader from '../../../../progressLoader';

import AssetViewer from '../../../../assets/assetViewer';
import ExternalAssetViewer from '../../../../assets/externalAssetViewer';


const ExternalViewerDialogAssetContent = props => {

    const [assetId, setAssetId] = useState<number>()



    useEffect(() => {
        if (
            props.viewerStore.selectedAssetId! === undefined
        ) {
            setAssetId(undefined);

        } else {
            setAssetId(props.viewerStore.selectedAssetId!);

        }
    }, []);




    return (
        <>
            {props.viewerStore.isLoading ? (<ProgressLoader />) :
                (
                    assetId == undefined ?
                        (<><SimpleGrid columns={2} spacing={3}>
                            No Asset Found
                        </SimpleGrid></>)
                        : (<ExternalAssetViewer assetId={assetId} sharedProjectId={props.spId} password={props.viewerStore.pwd} />))}
        </>
    );
}

ExternalViewerDialogAssetContent.propTypes = {
    handleClose: PropTypes.any,
    userId: PropTypes.any,
    viewerStore: PropTypes.any,
    spId: PropTypes.string,

}

export default observer(ExternalViewerDialogAssetContent)